import { render, staticRenderFns } from "./vehicleRepairEdit.vue?vue&type=template&id=28490766&scoped=true"
import script from "./vehicleRepairEdit.vue?vue&type=script&lang=js"
export * from "./vehicleRepairEdit.vue?vue&type=script&lang=js"
import style0 from "./vehicleRepairEdit.vue?vue&type=style&index=0&id=28490766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28490766",
  null
  
)

export default component.exports